// extracted by mini-css-extract-plugin
module.exports = {"left":"HomepageTop_left__1ppGh","left_tag":"HomepageTop_left_tag__1HuIv","left_desc":"HomepageTop_left_desc__pLu2R"};